import { Component, Input, ViewChild } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { AttachedFile, BaseState, FileView } from '@m4u-angular/base/entities/BaseEntities';
import { Notification } from '@base/entities/BaseEntities';
import { DomSanitizer } from '@angular/platform-browser';
import { FileEndpoint } from '@core/endpoints/file.endpoint';
import { Utils } from '@core/helpers/Utils';
import { PrintBoxDialogComponent } from '@ui/dialogs/printbox-dialog/printboxdialog.component';

class State extends BaseState {
    PreviewBody: any;
    FileView: FileView;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-email-history-item',
    templateUrl: './email-history-item.component.html',
    styleUrls: ['./email-history-item.component.scss']
})
export class EmailHistoryItemComponent extends BaseComponent<State> {

    @Input() Entity: Notification;
    @ViewChild(PrintBoxDialogComponent) printBoxDialog: PrintBoxDialogComponent;

    constructor(A: ServiceBagService,
        public sanitizer: DomSanitizer,
        private fileEndpoint: FileEndpoint) {
        super(A, 'EmailHistoryItemComponent', State);
    }

    protected override OnInitComponentFinished() {
        this.LoadAttachment();

        setTimeout(() => {
            this.State.PreviewBody = this.sanitizer.bypassSecurityTrustHtml(this.Entity.Body)
        });
    }

    OnGoToAttachment() {
        this.Do(this.fileEndpoint.GetView(this.Entity.SharedFileUID, true), false, response => {
            if (!response.IsSuccess) return;

            this.State.FileView = response.Entity;

            if (this.State.FileView.Extension == '.pdf') {
                this.printBoxDialog.PDFData = Utils.ConvertToBase64(this.State.FileView.FileData);
                this.printBoxDialog.ShowDialogShort(() => { });
                return;
            }

            const file = new AttachedFile;
            file.Extension = this.State.FileView.Extension;
            file.Name = this.State.FileView.Name;
            Utils.DoFileDownload(file, Utils.ConvertToBase64(this.State.FileView.FileData), this.State.FileView.ContentType);
        });
    }

    private LoadAttachment() {
        if (!this.Entity.SharedFileUID) return;
        this.Do(this.fileEndpoint.GetView(this.Entity.SharedFileUID, false), false, response => this.State.FileView = response.Entity);
    }
}
